import { createSlice } from '@reduxjs/toolkit'

import { NEXT_3_DAYS } from 'components/offer_availability'
import { camelize } from 'services/string_utils'


const initialState = {
  isOpen: false,
  initialEventType: null,
  eventType: null,
  availability: {
    availabilityOption: NEXT_3_DAYS,
    timezone: null,
    availableDays: {},
    datesWithSpots: {}
  }
}

const slice = createSlice({
  name: 'offerTimeSlotsModal',
  initialState,
  reducers: {
    openModal: (state, action) => ({
      ...state,
      isOpen: true,
      initialEventType: action.payload,
      eventType: camelize(action.payload)
    }),
    closeModal: () => initialState,
    storeEventType: (state, action) => {
      state.eventType = action.payload
    },
    updateAvailability: (state, action) => ({
      ...state,
      availability: {
        ...state.availability,
        ...action.payload
      }
    }),
  },
})

export const {
  reducer,
  actions: {
    openModal,
    closeModal,
    storeEventType,
    updateAvailability
  }
} = slice
